import { Component } from '@angular/core';
import { ConfirmNavigationOuter } from '@qv-ng1-wrapper/classes';

@Component({
  selector: 'qv-create-internal-bid',
  templateUrl: './create-internal-bid.component.html',
  styleUrls: ['./create-internal-bid.component.scss']
})
export class CreateInternalBidComponent extends ConfirmNavigationOuter {}
